/**
 * Human-readable one-line summary of an x-allOf rule. Used in the rule list,
 * in the confirm-version modal, and anywhere else we need to describe a rule
 * without rendering its full JSON.
 */
export function summarize(rule) {
	const ifs = (rule.ifConditions || [])
		.filter((c) => c.field)
		.slice(0, 2)
		.map((c) => c.field)
		.join(', ');
	const ifCount = (rule.ifConditions || []).length;
	const ifPart = ifs ? `IF ${ifs}${ifCount > 2 ? '…' : ''}` : 'IF (empty)';
	const thens = (rule.thenFields || []).slice(0, 2).map((f) => f.fieldName).join(', ');
	const thenCount = (rule.thenFields || []).length;
	const thenPart = thens ? `THEN ${thens}${thenCount > 2 ? '…' : ''}` : '';
	return `${ifPart}${thenPart ? ` → ${thenPart}` : ''}`;
}
